import React from "react";
import SEO from "../../components/seo";
import useProfilePic from "../../hooks/useProfilePic";
import ProfilePage from "../../layouts/ProfilePage";

const Kelly = () => {
	const { kelly: pic } = useProfilePic();
	return (
		<>
			<SEO
				title="Our Team of Specialists"
				keywords={[`Rheumatologist`, `Dr Kelly Morgan`]}
				description="About Dr Kelly Morgan"
			/>
			<ProfilePage
				title="Dr Kelly Morgan - Rheumatologist"
				name="Dr Kelly Morgan"
				img={pic.childImageSharp.fixed}
				quote="Treatment should improve your life, not get in the way of living it."
				specialty="Kelly has a particular interest in inflammatory arthritis, including rheumatoid arthritis, psoriatic arthritis and spondyloarthritis, as well as autoimmune connective tissue diseases and vasculitis. She also manages a broad range of general rheumatological conditions, including gout and polymyalgia rheumatica."
				education={[
					"Bachelor of Laws (with Distinction) – University of Western Australia",
					"Bachelor of Medicine/Bachelor of Surgery – University of Notre Dame, Fremantle",
					"Basic Physician Training – Sir Charles Gairdner Hospital",
					"Postgraduate Rheumatology Training – Royal Perth Hospital, Fiona Stanley Hospital, Sir Charles Gairdner Hospital",
					"Fellowship of the Royal Australasian College of Physicians (FRACP) – Adult Medicine Division",
				]}
				description={[
					"Dr Kelly Morgan is a consultant rheumatologist and Fellow of the Royal Australasian College of Physicians. She undertook her physician and specialist rheumatology training across Sir Charles Gairdner, Royal Perth and Fiona Stanley Hospitals.",
					"Kelly currently holds a consultant appointment in the Rheumatology Department at Sir Charles Gairdner Hospital, where she is involved in the management of a broad range of rheumatological conditions, including complex inflammatory and autoimmune diseases. She is also involved in the teaching and supervision of physicians and rheumatology trainees.",
					"During her rheumatology training, Kelly was awarded the Australian Rheumatology Association (WA) Research Fellowship in 2021 and contributed to published work in systemic sclerosis-associated interstitial lung disease, inflammatory myositis and gout.",
					"Prior to studying medicine, Kelly completed a Bachelor of Laws with Distinction at the University of Western Australia. After completing her law degree, she chose to pursue a career in medicine, going on to complete her medical degree at the University of Notre Dame Fremantle.",
				]}
				honours={[
					"Australian Rheumatology Association (WA) Research Fellowship, 2021",
					"Bachelor of Laws with Distinction, University of Western Australia, 2009",
					"Population and Preventative Health Award, University of Notre Dame School of Medicine, 2013",
					"Letters of Commendation for Academic Excellence, University of Notre Dame School of Medicine, 2011–2013",
				]}
				background={[
					"Kelly grew up in Perth. Her path to medicine was somewhat unconventional. She initially studied law, graduating with a Bachelor of Laws with Distinction from the University of Western Australia, before deciding to pursue a career in medicine and completing her medical degree at the University of Notre Dame Fremantle.",
					"Kelly undertook her physician and specialist rheumatology training in Perth and now works across both public and private practice. She is a consultant rheumatologist at Sir Charles Gairdner Hospital, where she has particular experience managing complex inflammatory and autoimmune rheumatic diseases.",
					"Kelly enjoys the breadth of rheumatology and the opportunity to develop long-term relationships with her patients. She values a thoughtful, practical and collaborative approach to care, with an emphasis on helping patients understand their condition and make informed decisions about their treatment.",
				]}
				appointments={[
					"Private appointment - Hollywood Private Hospital",
					"Public appointment - Sir Charles Gairdner Hospital",
				]}
				memberships={[
					"Australian Rheumatology Association (ARA)",
					"Australian Rheumatology Association – Early Career Rheumatologists",
					"Australian Medical Association (AMA)",
					"Royal Australasian College of Physicians (RACP)",
					"Australian Health Practitioner Regulation Agency (AHPRA)",
				]}
				personal={[
					"Outside of work, Kelly is kept busy by her 3 young children. Prior to having children, she enjoyed an active lifestyle including tennis, hockey, golf, swimming and running. These days, her physical activity is more likely to involve games of hide and seek and wrestling small children into car seats.",
					"Kelly loves to travel and explore new places, although family adventures are now often closer to home, particularly in Western Australia's beautiful South West. When the opportunity arises, she is also a firm believer in the value of a Saturday afternoon nap.",
				]}
				publications={[
					{
						publicationTitle:
							"Rituximab treatment for systemic sclerosis associated interstitial lung disease – A case series of 13 patients. Internal Medicine Journal. 2023.",
						authors: "Morgan K, Woollard C, Beinhart D, Host L, Roddy J.",
					},
					{
						publicationTitle: "Gout – the pivotal role of primary care. Medicine Today. 2021.",
						authors: "Pathmanathan K, Loh K, Morgan K, Keen HI.",
					},
					{
						publicationTitle:
							"Conventional ultrasound and elastography as imaging outcome tools in autoimmune myositis: A systematic review by the OMERACT ultrasound group. Seminars in Arthritis and Rheumatism. 2021.",
						authors: "Paramalingam S, Morgan K, Becce F, et al.",
					},
				]}
			/>
		</>
	);
};

export default Kelly;
